var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('h5',{class:[_vm.darkMode ? _vm.whiteText : '']},[_vm._v("Scroll Down")]),_c('i',{staticClass:"medium material-icons",class:[_vm.darkMode ? _vm.whiteText : '']},[_vm._v("arrow_downward")])])}
var staticRenderFns = []

export { render, staticRenderFns }